import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { extractContext, TOOLS } from "@/lib/tools";
import { DownloadSimple } from "@phosphor-icons/react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Front-end-only carry-over: copies a recent doc's title/context into the active wizard step.
export default function ContextCarryOver({ currentId, onPull }) {
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/documents");
        const list = res.data
          .filter((d) => d.id !== currentId)
          .sort((a, b) => (b.updated_at || b.created_at || "").localeCompare(a.updated_at || a.created_at || ""))
          .slice(0, 3);
        setRecent(list);
      } catch {
        /* ignore */
      }
    })();
  }, [currentId]);

  if (recent.length === 0) return null;

  const handle = (id) => {
    const doc = recent.find((d) => d.id === id);
    if (doc) onPull(extractContext(doc));
  };

  return (
    <div className="flex items-center gap-2 mb-1" data-testid="context-carryover">
      <DownloadSimple size={16} className="text-slate-400" />
      <Select onValueChange={handle}>
        <SelectTrigger data-testid="context-carryover-trigger" className="h-9 w-72 rounded-sm border-slate-300 text-sm">
          <SelectValue placeholder="Pull context from recent work…" />
        </SelectTrigger>
        <SelectContent>
          {recent.map((d) => (
            <SelectItem key={d.id} value={d.id} data-testid={`carryover-option-${d.id}`}>
              {d.title} · {TOOLS[d.tool_type]?.name || d.tool_type}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
